import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Navigate } from 'react-router';
import { Box, Divider, Select, Tab, Tabs, Typography } from '@mui/material';
import {
  AutocompleteInput,
  Datagrid,
  List,
  ReferenceArrayInput,
  ReferenceInput,
  Resource,
  SelectArrayInput,
  SelectInput,
  TextField,
  useGetList,
  useInfiniteGetList,
} from 'react-admin';
import CheckBoxAutoComplete from '../../utils/CheckboxesAutoComplete';
import { SetPropsType } from '../../utils/CheckboxesAutoComplete';
import { PharmacyDataType } from '../../utils/DataTypes';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Checkbox from '@mui/material/Checkbox';

const getOptionLabel = (option: PharmacyDataType) => {
  return option.pharmacy_npi;
};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const renderOptions = (props, option, { selected }) => (
  <li {...props}>
    <Checkbox icon={icon} checkedIcon={checkedIcon} checked={selected} />
    {option.pharmacy_npi}
  </li>
);

const PharmacyList = React.memo(({ setFunction }: SetPropsType) => {
  return (
    <>
      <ReferenceInput
        label="Pharmacy Name"
        source="pharmacy_npi"
        reference="pharmacy"
        sort={{ field: 'pharmacy_npi', order: 'ASC' }}
        sx={{ textTransform: 'capitalize', width: 300 }}
        optionText="pharmacy_npi"
        optionValue="pharmacy_network_name"
      >
        <CheckBoxAutoComplete
          setFunction={setFunction}
          label="Pharmacies"
          // placeholder=''
          //getOptionLabel={getOptionLabel}
          renderOptions={renderOptions}
          getOptionLabel={getOptionLabel}
          //getOptionSelected={(option) => option.year === 1994}
          //uiParams={uiParams}
        ></CheckBoxAutoComplete>
      </ReferenceInput>
    </>
  );

  /*  return (
        <>
            <ReferenceInput  label="Pharmacy Name" source="pharmacy_npi" reference="pharmacy" sort={{ field:"pharmacy_npi", order:"ASC" }} >
             <CheckBoxAutoComplete name="pharmacy" label={'Search By Pharmacy'} onChange={onPharmacyAutoCompleteChange} 
                placeholder="" id="pharmacy_autocomplete"
                optionText="pharmacy_npi" optionValue="pharmacy_network_name"
                ></CheckBoxAutoComplete>
            </ReferenceInput>
        </>
    ) */
});

//pharmacy_npi:""1902514722", "pharmacy_network_name": null
//optionValue="client_number" optionText="client_name"
export default PharmacyList;
